/**
 * Session D contacts mock (design-only). Close-on-outside-click hook for the
 * custom dropdowns. A document mousedown listener is used instead of a fixed
 * backdrop element because the sealed .sx-filters and the glass modal both set
 * backdrop-filter, which makes them the containing block for position:fixed
 * descendants; a fixed backdrop would be confined to that box rather than the
 * viewport. `setOpen` from useState is referentially stable, so the effect only
 * re-subscribes when `open` changes.
 */

import { useEffect, useRef } from "react";

export function useDismiss<T extends HTMLElement>(
  open: boolean,
  setOpen: (open: boolean) => void,
) {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open, setOpen]);
  return ref;
}
